import { Link } from 'react-router-dom'

const footerLinks = {
  product: [
    { label: 'Features', href: '/features' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Demo', href: '/demo' },
  ],
  company: [
    { label: 'About', href: '/about' },
    { label: 'Partner Programme', href: '/partner-programme' },
    { label: 'Contact', href: '/contact' },
  ],
  resources: [
    { label: 'Resources', href: '/resources' },
    { label: 'Value of Advice', href: '/value-of-advice' },
    { label: 'Help Us Build', href: '/help-us-build' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Security', href: '/security' },
  ],
}

export default function Footer() {
  return (
    <footer className="w-full bg-black/30 border-t border-white/[0.06] pt-20 pb-10 px-6 relative z-[1]">
      <div className="max-w-[1200px] mx-auto">
        {/* Main Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_2fr] gap-20 pb-15 border-b border-white/[0.06]">
          {/* Brand Section */}
          <div>
            <Link to="/" className="flex items-center gap-3 no-underline">
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none">
                <defs>
                  <linearGradient id="gradLogoFooter" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#2dd4bf" />
                    <stop offset="100%" stopColor="#10b981" />
                  </linearGradient>
                </defs>
                <path
                  d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z"
                  fill="url(#gradLogoFooter)"
                />
                <circle cx="18" cy="5" r="1.5" fill="#2dd4bf" />
                <circle cx="6" cy="18" r="1" fill="#10b981" />
              </svg>
              <div className="font-serif text-[22px] font-medium tracking-tight text-brand-light">
                Wealth<span className="text-accent-tealLight">Space</span>
              </div>
            </Link>
            <p className="text-[15px] text-brand-subtle leading-relaxed mt-5 max-w-[300px]">
              AI-powered software that transforms how financial advisers work, every single day.
            </p>
            <p className="text-[13px] text-accent-teal font-medium mt-3 italic">
              Built by Advisers. Run by Advisers. Owned by Advisers.
            </p>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-8">
            <FooterColumn title="Product" links={footerLinks.product} />
            <FooterColumn title="Company" links={footerLinks.company} />
            <FooterColumn title="Resources" links={footerLinks.resources} />
            <FooterColumn title="Legal" links={footerLinks.legal} />
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row justify-between items-center pt-[30px] gap-5">
          <p className="text-[13px] text-brand-subtle text-center sm:text-left">
            &copy; {new Date().getFullYear()} WealthSpace Ltd (Company No. 15396707). Registered in
            England &amp; Wales.
          </p>
        </div>
      </div>
    </footer>
  )
}

interface FooterColumnProps {
  title: string
  links: { label: string; href: string }[]
}

function FooterColumn({ title, links }: FooterColumnProps) {
  return (
    <div>
      <h4 className="text-[13px] font-semibold text-brand-muted uppercase tracking-[0.05em] mb-5">
        {title}
      </h4>
      {links.map((link) => (
        <Link
          key={link.href}
          to={link.href}
          className="block text-sm text-brand-subtle py-1.5 no-underline transition-colors duration-300 hover:text-brand-light"
        >
          {link.label}
        </Link>
      ))}
    </div>
  )
}
